import { Route, Routes } from "react-router-dom";
import "./App.css";
import "../src/assets/css/style-responsive.css";
import "rsuite/dist/rsuite.min.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Home from "./Components/Home";
import Culture from "./pages/Culture";
import Careers from "./pages/Careers";
import Marketplace from "./pages/Marketplace";
import MetalcloudApplication from "./pages/MetalcloudApplication";
import MetalCloudPg from "./pages/MetalCloudPg/MetalCloudPg";
import GetInTouch from "./pages/GetInTouch";
import EventsPage from "./Components/Footer/Events";
import AddressSection from "./Components/Footer/Address";
import PrivacySection from "./Components/Footer/PrivacyPolicy";
import TermsConditions from "./Components/Footer/Terms&Conditions";
import CompanyAnnualReport from "./Components/Footer/CompanyAnnualReport";
import CSR from "./Components/Footer/CSR";
import TheCalcuttaProject from "./Components/Footer/CSR/SocialCorporateRes";
import GreenNarrativeOfScrap from "./Components/Footer/GreenNarrativeOfScrap";
import { useEffect } from "react";
import { headerTitleJSON } from "./Components/constants";
import ReactGA from "react-ga4";
import NewsRoom from "./pages/NewsRoom";
import FundingRelease from "./pages/FundingRelease";
import FundingRelease80Cr from "./pages/FundingRelease80Cr";
import EsopsBuyBackRelease from "./pages/EsopsBuyBackRelease";
import CaseStudy from "./pages/CaseStudy/CaseStudy";
import CaseStudyDetail from "./pages/CaseStudy/CaseStudyDetail";
import FoundryDataTracking from "./pages/FoundryDataTracking/index.js";
import FinanceWebinar from "./pages/FinanceWebinar";
import Layout from "./Components/Layout/index.js";
import IPEX2026Pg from "./pages/IPEX2026Pg/IPEX2026Pg.jsx";

function App() {
  const headerTitle = headerTitleJSON.find(({ url }) => url === window.location.pathname);

  useEffect(() => {
    // The MetalCloud page sets its own title (and description) through Helmet;
    // writing document.title here would clobber it on every render.
    if (window.location.pathname === "/metalcloud") return;

    if (headerTitle?.text) {
      document.title =
        "NowPurchase || " +
        (headerTitle?.url === "/application" ||
        headerTitle?.url === "/metalcloud"
          ? "Metal Cloud"
          : headerTitle.text);
    } else {
      document.title = "NowPurchase || Home";
    }
  }, [headerTitle]);

  useEffect(() => {
    ReactGA.initialize("G-DPGLP1XHKS");
  }, []);

  return (
    <Routes>
      <Route element={<Layout />}>
        <Route exact path="/" element={<Home />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/culture" element={<Culture />} />
        <Route path="marketplace/*" element={<Marketplace />} />
        <Route path="/metalcloud" element={<MetalCloudPg />} />
        {/* Previous MetalCloud page, kept reachable for side-by-side comparison. */}
        <Route path="/metalcloud-old" element={<MetalcloudApplication />} />
        <Route path="/application" element={<MetalcloudApplication />} />
        <Route path="/getInTouchForm" element={<GetInTouch />} />
        <Route path="/events" element={<EventsPage />} />
        <Route path="/our-address" element={<AddressSection />} />
        <Route path="/privacy" element={<PrivacySection />} />
        <Route path="/terms-conditions" element={<TermsConditions />} />
        <Route path="/newsroom" element={<NewsRoom />} />
        <Route path="/casestudy" element={<CaseStudy />} />
        <Route path="/casestudy/:caseStudyId" element={<CaseStudyDetail />} />
        <Route path="/finance-webinar" element={<FinanceWebinar />} />
        <Route path="/investor-relations" element={<CompanyAnnualReport />} />
        {/* Old URL kept live so links already shared keep working. The page
            declares /investor-relations as its canonical, so search engines
            treat this as the same page rather than duplicate content. */}
        <Route
          path="/companyAnnualReport"
          element={<CompanyAnnualReport />}
        />
        <Route path="/csr" element={<CSR />} />
        <Route path="/educational-empowerement" element={<TheCalcuttaProject />} />
        <Route path="/scrap-recycling" element={<GreenNarrativeOfScrap />} />
        <Route path="/NowPurchase-raises-USD-6-million-in-funding-led-by-Infoedge-Ventures" element={<FundingRelease />} />
        <Route path="/NowPurchase-raises-80-cr-funding-led-by-Bajaj-Finserv" element={<FundingRelease80Cr />} />
        <Route path="/NowPurchase-completed-its-First-Ever-ESOP-Buyback" element={<EsopsBuyBackRelease />} />
        <Route path="/real-time-data-tracking" element={<FoundryDataTracking />} />
      </Route>
      <Route path="/ipex-2026" element={<IPEX2026Pg />} />
    </Routes>
  );
}

export default App;
